/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { User } from '../../User';
import { Text } from '../../Text';
import { getUserFromTransaction } from '../utils';
import { TRANSACTION_LABEL } from '../../../constants';
import { TransactionType, TransactionRole } from '@gopeerproject/chuck';
export const Info = ({ profile, type, role, participants, receivedAt, status, amount }) => {
    var _a;
    const styles = useStyleSheet(getStyles);
    const { name, image, finalType } = useMemo(() => getUserFromTransaction(profile, { role, participants }), [profile, role, participants]);
    const label = (role === TransactionRole.SUBSCRIPTION && amount === 0
        ? TRANSACTION_LABEL.TRIAL
        : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (_a = (role && TRANSACTION_LABEL[role])) !== null && _a !== void 0 ? _a : TRANSACTION_LABEL[status]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const labelStyle = (styles[label.value] || styles.paid);
    return (React.createElement(React.Fragment, null,
        React.createElement(User, { name: name, type: finalType, image: image, size: 'lg' }),
        React.createElement(View, { style: styles.wrapper },
            React.createElement(View, { style: styles.row },
                React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold', style: styles.name }, name),
                React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: labelStyle }, label.text.toUpperCase())),
            React.createElement(View, { style: [styles.row, styles.rowWithMargin] },
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.date }, moment(receivedAt).format('MMM D, yy')),
                React.createElement(Text, { type: 'headline', size: 'lg', style: styles.amount }, `$${Math.abs(type === TransactionType.CREDIT ? 0 : amount).toFixed(2)}`)))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    wrapper: { flex: 1, paddingHorizontal: size.G },
    row: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    rowWithMargin: {
        marginTop: size.B
    },
    name: {
        color: color.invert2.p100
    },
    date: {
        color: color.invert2.p56
    },
    amount: {
        color: color.invert2.p100
    },
    paid: { color: color.success.solid },
    credit: { color: color.parent.solid },
    onhold: { color: color.parent.solid },
    canceled: { color: color.negative.solid },
    failed: { color: color.negative.solid },
    referral: { color: color.parent.solid },
    sponsored: { color: color.primary.solid },
    free: { color: color.primary.solid }
}));
//# sourceMappingURL=Info.js.map